export {default as WeeklyCheckIns} from './WeeklyCheckIns.connect';
